/* GSW — sepet satırı "Edit" bağlantısı (30.08.2026)
 * Sorun: tema, satır özelliklerini DÜZ METİN basıyor; müşteri tasarımını
 * düzenlemek için adresi elle kopyalamak zorunda kalıyordu.
 * Çözüm: /apps/gang-sheets?design=… içeren özellik metinlerini tıklanabilir
 * butona çevirir, uzun Preview/Print adreslerini kısaltır. Tema dosyalarına
 * dokunmaz; yalnız sepet sayfası/çekmecesinde çalışır ve sepet AJAX ile
 * güncellendiğinde kendini tekrar uygular (MutationObserver).
 */
(function () {
  var EDIT_RE = /https?:\/\/[^\s"']+\/apps\/[a-z0-9-]+\?design=[A-Za-z0-9_-]+/i;
  var PREVIEW_RE = /https?:\/\/[^\s"']+\/files\/previews\/[^\s"']+/i;

  function styleLink(a, label, accent) {
    a.textContent = label;
    a.style.display = 'inline-flex';
    a.style.alignItems = 'center';
    a.style.gap = '6px';
    a.style.padding = '6px 12px';
    a.style.borderRadius = '8px';
    a.style.fontWeight = '700';
    a.style.fontSize = '13px';
    a.style.textDecoration = 'none';
    a.style.border = '1px solid ' + (accent ? '#f26b21' : '#d7d7d7');
    a.style.color = accent ? '#fff' : '#333';
    if (accent) a.style.background = 'linear-gradient(135deg,#f8893c,#f26b21)';
    a.setAttribute('data-gsw-linked', '1');
  }

  function walk(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var hits = [];
    var n;
    while ((n = w.nextNode())) {
      var t = n.nodeValue || '';
      if (t.length > 400) continue;
      if (EDIT_RE.test(t) || PREVIEW_RE.test(t)) hits.push(n);
    }
    for (var i = 0; i < hits.length; i++) {
      var node = hits[i];
      var parent = node.parentElement;
      if (!parent || parent.getAttribute('data-gsw-linked') === '1') continue;
      var text = node.nodeValue || '';
      var m = text.match(EDIT_RE);
      if (m) {
        var a = document.createElement('a');
        a.href = m[0];
        styleLink(a, '✏️ Edit this design', true);
        parent.textContent = '';
        parent.appendChild(a);
        parent.setAttribute('data-gsw-linked', '1');
        continue;
      }
      var p = text.match(PREVIEW_RE);
      if (p) {
        var b = document.createElement('a');
        b.href = p[0];
        b.target = '_blank';
        b.rel = 'noopener';
        styleLink(b, '🔍 Preview', false);
        parent.textContent = '';
        parent.appendChild(b);
        parent.setAttribute('data-gsw-linked', '1');
      }
    }
  }

  function run() {
    try {
      walk(document.body);
    } catch (e) {
      /* tema DOM'u beklenmedik — sessiz geç */
    }
  }

  function boot() {
    run();
    // sepet AJAX ile yeniden çizilince (adet değişimi, çekmece açılışı) tekrar uygula
    var pending = null;
    var mo = new MutationObserver(function () {
      if (pending) clearTimeout(pending);
      pending = setTimeout(run, 150);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
